'use client';

import { DashboardProgramSkeleton, OldProgramCard, ProgramWrapper } from '@insta-club/components';

const ProgramsBox = () => {
    return (
        <ProgramWrapper skeleton={<DashboardProgramSkeleton />}>
            {(programID: number) => <OldProgramCard programID={programID} />}
        </ProgramWrapper>
    );
};

export default ProgramsBox;

